import { useState } from "react";

import { cn } from "../utils/styling";

export const DropdownSingleSelectNative = ({
  className,
  disabled,
  displayOptions,
  disposeAfterSelection,
  label,
  onChange,
  options,
  placeholder,
  selectClassName,
  selectedValue,
  setSelectedValue,
  style,
}) => {
  if (!displayOptions) displayOptions = options;
  const [internalValue, setInternalValue] = useState(selectedValue);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedValue(value);
    if (onChange) onChange(event);

    if (disposeAfterSelection) setInternalValue("");
  };

  return (
    <div className={cn("w-full", className)} style={style}>
      <label htmlFor="a">{label}</label>
      <select
        className={cn(
          "w-full border-none bg-transparent px-2 font-ds-body-regular-md",
          disabled ? "" : "cursor-pointer",
          !selectedValue && "!text-lds-foreground-muted",
          selectClassName
        )}
        disabled={disabled}
        onChange={handleChange}
        value={disposeAfterSelection ? internalValue : selectedValue}
      >
        <option hidden selected value="">
          {placeholder}
        </option>
        {selectedValue && (
          <option disabled hidden value={selectedValue}>
            {selectedValue}
          </option>
        )}
        {options.map((_, index) => {
          return (
            <option className="text-lds-foreground-primary" key={index} value={options[index]}>
              {displayOptions[index]}
            </option>
          );
        })}
      </select>
    </div>
  );
};
